"use strict";
// see: https://arwiki.wiki/#/en/Universal-Data-License-How-to-use-it
// see: https://udlicense.arweave.dev/
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagNames = exports.Duration = exports.LicenseFee = exports.DataModelTraining = exports.CommercialUse = exports.Derivation = exports.LicenseOptionSettings = exports.UDL = exports.UDL_LICENSE_TX_ID = void 0;
// current release of the Universal Data License
exports.UDL_LICENSE_TX_ID = "IVjAM1C3x3GFdc3t9EqMnbtGnpgTuJbaiYZa1lk09_8";
class UDL {
    constructor(udlProto) {
        this.license = udlProto.id;
        this.derivations = (udlProto.derivations || []).map((derivation) => new Derivation(derivation));
        this.commercialUses = (udlProto.commercialUses || []).map((commercialUse) => new CommercialUse(commercialUse));
        this.dataModelTrainings = (udlProto.dataModelTrainings || []).map((dataModelTraining) => new DataModelTraining(dataModelTraining));
        this.licenseFee = udlProto.licenseFee ? new LicenseFee(udlProto.licenseFee) : undefined;
        this.currency = udlProto.currency;
        this.expires = udlProto.expires;
        this.unknownUsageRights = udlProto.unknownUsageRights;
        this.paymentAddress = udlProto.paymentAddress;
        this.paymentMode = udlProto.paymentMode;
    }
}
exports.UDL = UDL;
class LicenseOptionSettings {
    constructor(settingsProto) {
        this.type = settingsProto.type;
        this.value = settingsProto.value;
        this.fee = settingsProto.fee ? new LicenseFee(settingsProto.fee) : undefined;
        this.duration = settingsProto.duration ? new Duration(settingsProto.duration) : undefined;
    }
}
exports.LicenseOptionSettings = LicenseOptionSettings;
class Derivation extends LicenseOptionSettings {
}
exports.Derivation = Derivation;
class CommercialUse extends LicenseOptionSettings {
}
exports.CommercialUse = CommercialUse;
class DataModelTraining {
    constructor(settingsProto) {
        this.type = settingsProto.type;
        this.fee = settingsProto.fee ? new LicenseFee(settingsProto.fee) : undefined;
        this.duration = settingsProto.duration ? new Duration(settingsProto.duration) : undefined;
    }
}
exports.DataModelTraining = DataModelTraining;
class LicenseFee {
    constructor(licenseFeeProto) {
        this.type = licenseFeeProto.type;
        this.value = licenseFeeProto.value;
    }
}
exports.LicenseFee = LicenseFee;
class Duration {
    constructor(durationProto) {
        this.type = durationProto.type;
        this.value = durationProto.value;
    }
}
exports.Duration = Duration;
var tagNames;
(function (tagNames) {
    tagNames["LICENSE"] = "License";
    tagNames["ACCESS_FEE"] = "Access-Fee";
    tagNames["DERIVATION"] = "Derivation";
    tagNames["COMMERCIAL_USE"] = "Commercial-Use";
    tagNames["PAYMENT_MODE"] = "Payment-Mode";
    tagNames["PAYMENT_ADDRESS"] = "Payment-Address";
    tagNames["EXPIRY"] = "Expiry";
    tagNames["CURRENCY"] = "Currency";
    tagNames["UNKNOWN_USAGE_RIGHTS"] = "Unknown-Usage-Rights";
    tagNames["DATA_MODEL_TRAINING"] = "Data-Model-Training";
})(tagNames = exports.tagNames || (exports.tagNames = {}));
;
